import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  height: calc(100vw * 0.375);
  gap: 10px;
  justify-content: center;

  @media (${laptopMediumMax}) {
    flex-direction: column;
    height: auto;
  }
`;

export const HoverOverlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.25);
  opacity: 0;
  transition: 200ms all;
`;

export const MoreOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
  color: white;
  font-weight: bold;
  font-size: 40px;

  @media (${mobileXXLargeMax}) {
    font-size: 32px;
  }
`;

export const MediaOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;

  p {
    margin-top: 8px;
    font-size: 16px;
    font-weight: bold;
  }
`;

export const LargeThumb = styled.button`
  position: relative;
  overflow: hidden;
  flex: 1;
  cursor: zoom-in;
  max-width: 50%;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    ${HoverOverlay} {
      opacity: 1;
    }
  }

  @media (${laptopMediumMax}) {
    max-width: 100%;
    flex: 0 0 100%;
    max-height: 75vw;
  }
`;

export const Expander = styled.div`
  position: absolute;
  right: 15px;
  bottom: 15px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 10px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => theme.primary};
  }

  svg {
    transform: scaleX(-1);
  }
`;

export const SmallThumbs = styled.div<{ $total: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  flex-direction: column;
  flex: ${({ $total }) => ($total >= 4 ? '1' : '0 0 calc(25% - 5px)')};

  @media (${laptopMediumMax}) {
    flex-direction: row;
  }
`;

export const SmallThumb = styled.button<{ $total: number }>`
  position: relative;
  flex: 1;
  max-width: ${({ $total }) => ($total <= 3 ? `100%` : `calc(50% - 5px)`)};
  min-height: calc(50% - 5px);
  max-height: calc(50% - 5px);
  cursor: zoom-in;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:hover {
    ${HoverOverlay} {
      opacity: 1;
    }
  }

  &:nth-child(2) {
    ${MoreOverlay} {
      display: ${({ $total }) => ($total === 3 ? 'flex' : 'none')};
    }
  }

  @media (${laptopMediumMax}) {
    height: 35vw;
    flex: 0 0 calc(50% - 5px);
    max-width: calc(50% - 5px);

    &:nth-child(2) {
      ${MoreOverlay} {
        display: flex;
      }
    }

    &:nth-child(3),
    &:nth-child(4) {
      display: none;
    }
  }
`;
